<template>
  <div class="login container d-flex justify-content-center">

    <form @submit.prevent="submit" autocomplete="off" id="form">
      
      <div class="row">
      <h2 class="col-md-12 pt-2 pb-4">Enter PIN</h2>
      </div>

          <div class="row size-limit">

            <div class="col-3 pl-3 d-flex justify-content-center">
                <text-input type="pin" v-model="first" name="pin_first" v-validate="'required'" :hideErrors="true" />
            </div>
            <div class="col-3 d-flex justify-content-center">
                <text-input type="pin" v-model="second"  name="pin_second" v-validate="'required'" :hideErrors="true" />
            </div>
            <div class="col-3 d-flex justify-content-center">
                <text-input type="pin" v-model="third" name="pin_third" v-validate="'required'" :hideErrors="true" />
            </div>
            <div class="col-3 pr-3 d-flex justify-content-center">
                <text-input type="pin" v-model="fourth" name="pin_fourth" v-validate="'required'" :hideErrors="true" />
            </div>
          </div>



          <div class="row">
            <p class="is-danger" v-if="show_error">Incorrect pin. {{pin_attempts_remaining}} tries remaining</p>
          </div>
       






        <div class="row">
          <cta class="col-md-12 pl-1 pr-1 pt-5" type="submit" shape="circle" text="" icon="right-arrow" :disabled="!completed_pin || this.errors.items.length" margin="no-margin" :loading="submitted" />
        </div>


      

    </form>   

  </div>
</template>

<script>
export default {
  name: 'Login',
  inject: ['$validator'],
  data : function(){       
      return {
          first    :'',
          second   :'',
          third    :'',
          fourth   :'',
          submitted:false,
          show_error:false
      };
  },
  mounted:function(){
    this.selectInput();    
  },
  computed: {
      completed_pin(){
        return this.first + this.second + this.third + this.fourth;
      },
      intended_url(){
        return this.$store.getters.getIntendedUrl;
      },
      account_id(){
        let account =  this.$store.getters.getAccount;
        if(account.id)
          return account.id;
        return false;
      },

      pin_attempts(){
        return this.$store.getters.getPinAttempts;
      },

      pin_attempts_remaining(){
        return process.env.VUE_APP_PIN_ATTEMPTS - this.pin_attempts;
      }

  },
  watch :{

   /* pin:{
      handler: function(newVal, oldVal){

        this.selectInput();
        
      },
      deep:true
    },*/

    show_error(newVal){
      if(newVal){
        setTimeout(()=>{ this.show_error = false }, 3000);
      }
    },

    completed_pin(newVal){
      this.selectInput();
      if(newVal.length == 4)
        this.submit(newVal);
    },




  },
  methods:{

    blur(){
      this.selectInput();
    },


    reset(){
      this.first = this.second = this.third = this.fourth = '';
    },

    selectInput(){
      if(!this.first)
        document.querySelector("input[name='pin_first']").focus();
      else if(!this.second)
        document.querySelector("input[name='pin_second']").focus();
      else if(!this.third)
        document.querySelector("input[name='pin_third']").focus();
      else if(!this.fourth)
        document.querySelector("input[name='pin_fourth']").focus();

    },

    submit(pin){
      this.submitted = true;
      this.show_error = false;

      this.$store.commit('INCREMENT_PIN_ATTEMPTS');

      window.axios({
        url: process.env.VUE_APP_API_GRAPH_URL,
        method: 'post',
        data: {
          query: `
            query($account_id:Int!,$pin:String!){
              validatePin(
                account_id:$account_id, 
                pin:$pin
              )
            }
            `,
            variables: {
              account_id: this.account_id,
              pin       : pin
            }
        }
      }).then((result) => {
        if(result.data.data.validatePin){ // correct pin
          this.$store.commit("SET_PIN_LOCKED",false);
          this.$store.commit("RESET_PIN_ATTEMPTS");
          this.$router.push({ name: this.intended_url});
        }else{ // incorrect pin
          this.reset();
          if(process.env.VUE_APP_PIN_ATTEMPTS - this.pin_attempts < 1){ // too many attempts
            this.$store.dispatch('logout');
          }
          this.show_error = true;
        }
      }).catch( () => {
          this.$bus.$emit('error_message', 'Something went wrong, please try again!');
      }).then(() => {
          this.submitted = false;
      });

    },


  }
}
</script>

<style scoped>

.pin_holder{
  width:336px;
  margin:0 auto;
}

.pin_col{
  float:left;
  margin-left:10px;
  margin-right:10px;
}

.is-danger{
  clear:both;
  padding-top:10px;
}



.cta_rights{
  padding: 20px;
}



</style>
